import { GaTrackingEventCategory } from '~shared/modules/ga-tracking/constants';
import { ApplicationEventType } from '../constants';
import { ApplicationEvent } from './application-event.model';

export class ChangeDeliveryAddressApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.ChangeDeliveryAddress;

  getPayload(): any {
    return {
      label: 'Change delivery address clicked',
      gtmCustom: {
        category: GaTrackingEventCategory.Interaction,
      }
    };
  }
}
